import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/movies";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/70 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2 shrink-0" aria-label="八戒影院首页">
          <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-lg font-bold">
            八
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            八戒影院
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-accent-600 hover:bg-accent-50 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          <a
            href="#latest"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-base" aria-hidden="true" />
            立即看片
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-sm font-medium text-foreground-700 bg-background-100 hover:bg-accent-50 hover:text-accent-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#latest"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold cursor-pointer"
          >
            <i className="ri-play-circle-line" aria-hidden="true" />
            立即看片
          </a>
        </div>
      )}
    </header>
  );
}